import { useMemo } from 'react';

import { useQueryClient } from '@mint-lib/query-client';
import { Chat } from '@mint-sdk/api-ai-assistant';

/*FYI: This is useStubMessage hook is needed to create temporary messages
 First message in chat will be printed immediately and we have to display it
 while assistant is processing

 Currently if we have 500 from BE we display red error block with text.
 500 errors BE doesn't store in DB so we have to temporarily store it on UI until user refreshes page
 The structure of temporary messages should be very close to the messages stored in the database
 */

export const useStubMessage = (chatId?: string) => {
  const queryClient = useQueryClient();
  const currentDate = new Date().toISOString().replace('Z', '');

  const lastMessageId = useMemo(() => {
    let messageId = 1;
    if (chatId) {
      const msgHistory: Chat.ChatMessageRecordType[] =
        queryClient.getQueryData(
          Chat.getHistoryById({ urlParams: { chatSessionId: chatId } })
            .queryKey,
        ) ?? [];

      messageId = Number(msgHistory?.at(-1)?.messageId) + 1 || 1;
    }

    return messageId;
  }, [queryClient, chatId]);

  const createStubMessage = (
    prompt: { text: string; metadata?: Chat.UserMetadataSchemaType },
    options?: { isApprovingStub?: boolean },
  ): Chat.UserChatMessageRecordType => {
    const userMessage: Chat.UserChatMessageRecordType = {
      createdAt: currentDate,
      messageId: lastMessageId,
      message: {
        type: 'human',
        additionalMetadata: {
          metadata: prompt.metadata,
        },
        content: prompt.text,
        isMsgStub: true,
      },
    };

    if (options?.isApprovingStub) {
      return {
        ...userMessage,
        message: { ...userMessage.message, isApprovingStub: true },
      };
    }

    return userMessage;
  };

  const createSystemErrorMessage = (): Chat.AiChatMessageRecordType => {
    const text = 'Something went wrong due to a technical problem.';

    return {
      createdAt: currentDate,
      messageId: lastMessageId,
      message: {
        type: 'ai',
        content: text,
        additionalMetadata: {
          isLast: true,

          metadata: {},
          statusCode: 500,
        },
        isSystemError: true,
      },
    };
  };

  return {
    createSystemErrorMessage,
    createStubMessage,
  };
};
